//Function to handle a text maximum length.
export const shortenText = (text: string | null, maxLength: number) => {
    if (text === null) return;
    if (text.length <= maxLength) {
        return text;
    }
    return text.slice(0, maxLength) + "...";
};